'use client'

import React, { useEffect, useState } from 'react'
import Chart from 'react-apexcharts'
import { Card } from 'flowbite-react'
import { loadPosSalesReport } from './apis/reportsAPI'
import { stackedChartOptions } from './utils/chartVariables'
import { Col, DatePicker, Row } from 'antd'
import Filters from '../globalComponents/Filters'
import formatAmount from '../utils/formatAmount'
import GHSymbol from '../globalComponents/GHSymbol'
import dayjs from 'dayjs';
import Loading from './components/Loading'

const options = {
  chart: {
    id: 'basic-bar',
    // height: 350,
    type: 'area'
  },

  stroke: {
    // curve: 'smooth'
  },
  dataLabels: {
    enabled: false
  },
  tooltip: {
    x: {
      format: 'dd/MM/yyyy'
    }
  },
  title: {
    text: 'Sales per Employee'
  },
  fill: {
    opacity: 1
  }
}

const series = [
  {
    name: 'series1',
    data: [0,40, 28, 51, 42, 109, 100]
  },
  {
    name: 'series2',
    data: [11, 32, 45, 32, 34, 52, 41]
  }
]

// var options = {
// dataLabels: {
//   enabled: false
// },
// stroke: {
//   curve: 'smooth'
// },
// xaxis: {
//   type: 'datetime',
//   categories: ["2018-09-19T00:00:00.000Z", "2018-09-19T01:30:00.000Z", "2018-09-19T02:30:00.000Z", "2018-09-19T03:30:00.000Z", "2018-09-19T04:30:00.000Z", "2018-09-19T05:30:00.000Z", "2018-09-19T06:30:00.000Z"]
// },
// tooltip: {
//   x: {
//     format: 'dd/MM/yy HH:mm'
//   },
// },
// };


const Dashboard = () => {
  const [report, setReport] = useState({series: [], categories: []});
  const [filterDate, setFilterDate] = useState([dayjs('2025-01-01', 'YYYY-MM-DD'), dayjs('2025-01-31', 'YYYY-MM-DD')]);
  // console.log(report)
  useEffect(() => {
    let date = [...filterDate];
    if (filterDate.length > 1) {
      date[0] = new Date(filterDate[0]).toLocaleDateString();
      date[1] = new Date(filterDate[1]).toLocaleDateString(); 
    }
    loadPosSalesReport(date.length > 0 ? date : null)
    .then(res => setReport(res))
    .catch(err => console.log(err))
  },[filterDate])



  return (
    <div className='mx-auto container' style={{maxWidth: '1400px'}}>
      <div>

      </div>
      <div className='mixed-chart'>
        <Row gutter={10}>
          <Col md={{span: 12}}>
            <div className='shadow bg-white '>
              <div className='flex justify-between items-center p-2'>
                <div>
                  <h5 className='text-2xl font-bold tracking-tight text-gray-900 dark:text-white'>
                    GHc {new Intl.NumberFormat('en-Gh', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(report.totalSales)}
                  </h5>
                  <span className='text-gray-400'>Sales this week</span>
                </div>
                <div>
                  <div className='flex'>
                    <DatePicker.RangePicker value={filterDate} allowClear={false} onChange={e => setFilterDate(e)} />
                  </div>
                  <p className='font-normal dark:text-gray-400 text-green-500'>
                    +29%
                  </p>
                </div>
              </div>
              <Chart 
                options={{...options, xaxis: {categories: report.categories, type: 'datetime'}}}
                series={report.series}
                // options={options}
                // series={series}
                type='area'
                width='100%'
                height={'300'}
              />
            </div>
          </Col>
          <Col md={{span: 12}}>
            <div className='shadow bg-white '>
              <Chart 
                options={{
                  ...stackedChartOptions, 
                  xaxis: {categories: report.categories, type:'datetime'},
                  // title: {
                  //   text: 'GHc ' + formatAmount(report.totalSales),
                  //   style: {fontSize: '22px'}
                    
                  // },
                  // subtitle: {
                  //   text: 'Sales per Cashiers',
                  //   style: {fontSize: '17px'}
                  // }
                }}
                series= {report.series || []}
                type='bar'
                width='100%'
                height={'300'}
              />
            </div>
          </Col>
        </Row>
      </div>
      
    </div>
  )
}

export default Dashboard;

/* .apexcharts-legend {	
        display: flex;	
        overflow: auto;	
        padding: 0 10px;	
      }	
      .apexcharts-legend.apx-legend-position-bottom, .apexcharts-legend.apx-legend-position-top {	
        flex-wrap: wrap	
      }	
      .apexcharts-legend.apx-legend-position-right, .apexcharts-legend.apx-legend-position-left {	
        flex-direction: column;	
        bottom: 0;	
      }	
      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-left, .apexcharts-legend.apx-legend-position-top.apexcharts-align-left, .apexcharts-legend.apx-legend-position-right, .apexcharts-legend.apx-legend-position-left {	
        justify-content: flex-start;	
      }	
      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-center, .apexcharts-legend.apx-legend-position-top.apexcharts-align-center {	
        justify-content: center;  	
      }	
      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-right, .apexcharts-legend.apx-legend-position-top.apexcharts-align-right {	
        justify-content: flex-end;	
      }	
      .apexcharts-legend-series {	
        cursor: pointer;	
        line-height: normal;	
      }	
      .apexcharts-legend.apx-legend-position-bottom .apexcharts-legend-series, .apexcharts-legend.apx-legend-position-top .apexcharts-legend-series{	
        display: flex;	
        align-items: center;	
      }	
      .apexcharts-legend-text {	
        position: relative;	
        font-size: 14px;	
      }	
      .apexcharts-legend-text *, .apexcharts-legend-marker * {	
        pointer-events: none;	
      }	
      .apexcharts-legend-marker {	
        position: relative;	
        display: inline-block;	
        cursor: pointer;	
        margin-right: 3px;	
        border-style: solid;
      }	
      	
      .apexcharts-legend.apexcharts-align-right .apexcharts-legend-series, .apexcharts-legend.apexcharts-align-left .apexcharts-legend-series{	
        display: inline-block;	
      }	
      .apexcharts-legend-series.apexcharts-no-click {	
        cursor: auto;	
      }	
      .apexcharts-legend .apexcharts-hidden-zero-series, .apexcharts-legend .apexcharts-hidden-null-series {	
        display: none !important;	
      }	
      .apexcharts-inactive-legend {	
        opacity: 0.45;	
      } */
